type ObjToKey<T> = keyof T
//原片管理-特别材质
const specialMaterialTable = [
  'matCode',
  'color',
  'thick',
  'width',
  'height',
  'isPicked',
]

//原片管理-品牌材质
const brandMaterialTable = [
  'brand_name',
  'supplier_name',
  'matCode',
  'color',
  'thick',
  'width',
  'height',
  'trim_edge',
  'is_high_gloss_plank',
]

// 原片管理-原片下料刀
const blankKnifeTable = ['matCode', 'thick', 'is_highlight', 'knife']

// 余料管理-余料清单
const surplusDepotTable = [
  'surplus_name',
  'shape',
  'matCode',
  'color',
  'thick',
  'long',
  'width',
  'min_long',
  'min_width',
  'area',
  'surplus_trim_edge',
  'amount',
  'is_high_gloss_plank',
  'branch_name',
  'remark',
]

// 补件和待排版库-板件
const bujianPlankTable = [
  'address',
  'customer_name',
  'plankID',
  'matCode',
  'texture',
  'sizeStr',
  'plankNum',
  'create_time',
]

// 余料管理-余料库
const surplusStoreTable = [
  'branch_no',
  'store_name',
  'quantity',
  'capacity',
  'surplus_rules',
  'remark',
]

//开料机设置=孔槽
const holeSlotTable = ['name', 'Depth', 'Width', 'Diameter']

//开料机-刀具库
const knifeStoreTable = [
  'desc',
  'name',
  'diameter',
  'type',
  'cutable',
  'use',
  'moveZF',
  'cutZF',
  'moveF',
  'cutF',
  'startCode',
  'stopCode',
  'startCode2',
  'stopCode2',
  'preStartCode',
  'length',
  'maximum_single_depth',
  'axis_offset',
  'arc_radius',
]

//雕刻机-排钻设置
const knifeToolTable = [
  'isUsed',
  'number',
  'number2',
  'diameter',
  'xOffset',
  'yOffset',
  'moveZF',
  'feedRate',
  'moveF',
  '_selected',
]

//雕刻机切割参数
const cuttingParamsPlankTable = [
  'matCode',
  'highlight',
  'pThick',
  'firstCut',
  'secondCut',
  'thirdCut',
]
//贴标设置-排版图设置
const layoutSettingsTable = [
  'enable',
  'imageNamePrefix',
  'imageSize',
  'imageFormat',
  'imageDirection',
]

//电子据自定义表格
const customerFormTable = ['importHeader', 'headerString']

//侧孔机刀具库
const sideHoleKnifeStoreTable = [
  'id',
  'diameter',
  'xOffset',
  'yOffset',
  'zOffset',
  'startCode',
  'endCode',
]

//侧孔机正面加工刀具库
const sideHoleFrontKnifeStoreTable = [
  'id',
  'knifePurpose',
  'diameter',
  'x_offset',
  'y_offset',
  'z_offset',
  'startCode',
  'endCode',
]

//PTP刀具库
const ptpKnifeStoreTable = [
  'id',
  'type',
  'diameter',
  'offsetX',
  'offsetY',
  'offsetZ',
  'offsetNo',
  'cutVelocity',
  'drillVelocity',
  'rotationlSpeed',
]

// 门套机表格数据
const mentaojiSawTable = [
  'serial_num',
  'saw_width',
  'saw_direction',
  'cut_from',
  'move_speed',
  'cut_speed',
  'start_code',
  'end_code',
  'saw_down_code',
  'saw_up_code',
  'abscissa',
  'ordinate',
  'x_offset',
  'y_offset',
]

// 从孔列表数据
const sideHoleDrillSettingDrillCombinationFromHoleTable = [
  'name',
  'knifePrefix',
  'knifeSuffix',
]

// 侧孔机旧版设置自定义1
const sideHoleOldKnifeStoreTableV1 = [
  'id',
  'diameter',
  'type',
  'moveSpeed',
  'doSpeed',
  'startCode',
  'endCode',
]

// 侧孔机旧版设置自定义3
const sideHoleOldKnifeStoreTableV3 = [
  'knifeName',
  'type',
  'diameter',
  'moveSpeed',
  'doSpeed',
  'startCode',
  'endCode',
]

// 侧孔机旧版设置自定义4
const sideHoleOldKnifeStoreTableV4 = [
  'knifeName',
  'diameter',
  'startCode',
  'endCode',
]

//一体机-刀具库
const modelAioTable = [
  'name',
  'diameter',
  'type',
  'use',
  'moveZF',
  'cutZF',
  'moveF',
  'cutF',
  'xOffset',
  'yOffset',
  'zOffset',
  'startCode',
  'stopCode',
  'axis_offset',
  'arc_radius',
]
// 雕刻机切割参数特殊孔槽自定义加工面
const custom_special_hole_slot_side = [
  'specialHoleSlot',
  'diameter',
  'long_side',
  'short_side',
  'side',
]
// 雕刻机切割参数设置不生效翻面两次打穿孔
const custom_through_two_side_to_cut_table = ['specialHoleSlot', 'diameter']
// 雕刻机切割参数-边缘槽隔条防断规则
const preventBreakageRulesTable = [
  'edge_distance',
  'edge_part_length',
  'slot_depth',
  'first_cut_deep',
]
const fiveSixKnivesTable = ['idx', 'diameter', 'five_six_use', 'knife_name']
const plankNamePlacementTable = ['plank_name', 'plank_edge', 'device_side']
const bigPlankLengthMarkingRangeTable = ['min_length', 'max_length', 'marking']
const bigPlankThicknessMarkingRangeTable = [
  'min_thick',
  'max_thick',
  'thick_mark',
]
const singleFileHoleRangeTable = ['hole_operator', 'hole_value']
const singleFileSlotRangeTable = [
  'slot_length_operator',
  'slot_length_value',
  'slot_width_operator',
  'slot_width_value',
]

// 激光一体机-反面刀库
const laserCuttingMachineTable = [
  'desc',
  'name',
  'diameter',
  'type',
  'cutable',
  'use',
  'moveZF',
  'cutZF',
  'moveF',
  'cutF',
  'startCode',
  'stopCode',
]

// 开料清单-自定义表头
const materialListTableHeader = ['label', 'customLabel', 'temp']

// 搭桥留点法-生成方式
const bridgeCountRulesTable = ['plankLength', 'count']

const tableColumns = {
  special_material_table: specialMaterialTable, //原片管理-特别材质
  brand_material_table: brandMaterialTable, //原片管理-品牌材质
  blank_knife_table: blankKnifeTable, //原片管理-原片下料刀
  surplus_depot_table: surplusDepotTable, //余料管理-余料清单
  surplus_store_table: surplusStoreTable, //余料管理-余料库
  bujian_plank_table: bujianPlankTable, //补件和待排版库-板件
  hole_slot_table: holeSlotTable, //开料机设置=孔槽
  knife_store_table: knifeStoreTable, //开料机-刀具库
  knife_tool_table: knifeToolTable, //雕刻机-排钻设置
  cutting_params_plank_table: cuttingParamsPlankTable, //雕刻机切割参数
  custom_special_hole_slot_side_table: custom_special_hole_slot_side, //雕刻机切割参数特殊孔槽自定义加工面
  layout_settings_table: layoutSettingsTable, //贴标设置-排版图设置
  customer_form_table: customerFormTable, //电子据自定义表格
  side_hole_knife_store_table: sideHoleKnifeStoreTable, //侧孔机刀具库
  side_hole_front_knife_store_table: sideHoleFrontKnifeStoreTable, //侧孔机正面加工刀具库
  ptp_knife_store_table: ptpKnifeStoreTable, //PTP刀具库
  mentaoji_saw_table: mentaojiSawTable, // 开料机-门套机表格
  side_hole_drill_setting_drill_combination_from_hole_table:
    sideHoleDrillSettingDrillCombinationFromHoleTable, // 雕刻机-排钻设置-组合下刀-从孔列表
  side_hole_old_knife_store_table_v1: sideHoleOldKnifeStoreTableV1, // 侧孔机-旧版设置-自定义1
  side_hole_old_knife_store_table_v3: sideHoleOldKnifeStoreTableV3, // 侧孔机-旧版设置-自定义3
  side_hole_old_knife_store_table_v4: sideHoleOldKnifeStoreTableV4, // 侧孔机-旧版设置-自定义4
  model_aio_table: modelAioTable, // 一体机设置-刀具
  five_six_knives_table: fiveSixKnivesTable, // 五六面钻-刀库
  plank_name_placement_table: plankNamePlacementTable, // 五六面钻-指定板件名摆放
  custom_through_two_side_to_cut_table: custom_through_two_side_to_cut_table, // 雕刻机切割参数设置不生效翻面两次打穿孔
  prevent_breakage_rules_table: preventBreakageRulesTable, // 雕刻机切割参数-边缘槽隔条防断规则
  big_plank_length_marking_range_table: bigPlankLengthMarkingRangeTable, // 雕刻机雕刻参数-大板长度标识
  big_plank_thickness_marking_range_table: bigPlankThicknessMarkingRangeTable, // 雕刻机开料对接-大板厚度标识
  single_file_hole_range_table: singleFileHoleRangeTable, // NC导出-孔生效范围
  single_file_slot_range_table: singleFileSlotRangeTable, // NC导出-槽生效范围
  laser_cutting_machine_table: laserCuttingMachineTable, // 激光一体机-反面刀库
  material_list_table_header: materialListTableHeader, // 开料清单-自定义表头
  bridge_count_rules_table: bridgeCountRulesTable, // 搭桥留点法-生成方式
}
tableColumns.hole_slot_table.filter((it) => it === 'Depth')
export default function getTableColumns(type: ObjToKey<typeof tableColumns>) {
  return tableColumns[type]
}
